import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Tabs,
} from "antd";
import { useState } from "react";
import MainLayout from "../../../components/mainLayout";
import "./Banner.scss";
import UploadMultiple from '../../../commons/UploadMultiple/UploadMultiple';
import BlockForm from '../../../components/form/blockForm';
import { authApis } from "../../../services/authApi";
import { nofication } from '../../../commons/Nofication';
import { useParams } from 'react-router-dom';
import { ROOT_URL } from "../../../constants/api";
import BackButton from "../../../commons/BackButton";
import { useNavigate } from 'react-router-dom';

const { TabPane } = Tabs;
const style = { padding: "8px 20px" };
const onChange = (key) => {
    console.log(key);
};

const AddBannerInvestor = () => {
    const history = useNavigate();
    const [fileList, setFileList] = useState([]);
    const [imageUrl, setImageUrl] = useState([]);
    const [idsRemove, setIdsRemove] = useState([]);
    const [imgCurrent, setImgCurrent] = useState([]);
    const [form] = Form.useForm();
    let { id } = useParams();
    const [content, setContent] = useState({
        content_vi: "",
        // content_en: "",
        // content_kr: "",
        // content_cn: "",
        // content_jp: "",

    });
    const onChangeContentValue = (lang) => {
        console.log('lang')
    }
    useState(() => {
        if (id) {
            authApis
                .getDetailHoiDap(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        form.setFieldsValue(data.hoiDap)
                        setContent({
                            content_vi: data.hoiDap?.content_vi ?? '<p></p>',
                            // content_en: data.banner?.content_en ?? '<p></p>',
                            // content_kr: data.banner?.content_kr ?? '<p></p>',
                            // content_cn: data.banner?.content_cn ?? '<p></p>',
                            // content_jp: data.banner?.content_jp ?? '<p></p>',
                        });
                    } else {
                        nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                    }
                })
                .catch((errors) => {
                    nofication('error', 'Thất bại', 'Không kết nối được server');
                    console.log(errors)
                });
        }
    })

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            if (key === 'content_vi' || key === 'content_en' || key === 'content_kr' || key === 'content_cn' || key === 'content_jp') {
                formData.append(key, values[key]?.editor ? values[key]?.editor.getData() : values[key]);
            } else {
                formData.append(key, values[key]);
            }
        }
        id && formData.append('id', id);

        // if (fileList && fileList.length !== 0){
        //     for (let i = 0; i < fileList.length; i++) {
        //         formData.append('logo' + i, fileList[i])
        //         console.log('fileList[i]',fileList[i])
        //     }
        // }
        // formData.append('total', fileList && fileList.length)
        // formData.append('idsRemove', idsRemove)
        // formData.append('type', 0)
        await authApis
            .addHoiDap(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    // setImageUrl([...data.images])
                    // setFileList([])
                    nofication('success', 'Thành công', 'Cập nhật thành công!');
                    form.resetFields();
                    setContent({
                        content_vi: '',
                    });
                    history('/tuyen-sinh/hoi-dap');
                } else {
                    nofication('error', 'Thất bại', 'Vui lòng kiểm tra lại thông tin !');
                }
            })
            .catch((errors) => {
                nofication('error', 'Thất bại', 'Không kết nối được server');
                console.log(errors)
            });
    };

    return (
        <MainLayout
            isShowActionHeader={false}
            title="Hỏi đáp"
            link="/tuyen-sinh/hoi-dap/"
            titleNew="Tuyển sinh / Hỏi đáp / Tạo mới"
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                colon={true}
                initialValues={{ type: 1 }}
            >
                <Row gutter={16} style={{ minHeight: "873px" }}>
                    <Col span={24} className='pad'>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <BlockForm lang={'vi'} onChangeContentValue={onChangeContentValue} content={content} id={id} />
                                </TabPane>
                            </Tabs>
                            <Form.Item label="Khối" colon={true} name="type">
                                <Select>
                                    <Select.Option value={1}>Khối mầm non</Select.Option>
                                    <Select.Option value={2}>Khối tiểu học</Select.Option>
                                    <Select.Option value={3}>Khối trung học cơ sở</Select.Option>
                                    <Select.Option value={4}>Khối trung học phổ thông</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton />
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default AddBannerInvestor;
